import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form/immutable';

import { clearModal } from '../../actions/modal';
import { addTrackedVideo } from './actions';
import TextInput from '../../components/form-input-text';
import { TRACKED_ASSET } from '../../utils/static-configuration';

class TrackAssetModal extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  componentWillUnmount() {
    this.onClearModal();
  }

  onOutsideClick = event => {
    const isClickInside = this.refs.modal_content.contains(event.target);
    if (!isClickInside) {
      this.onClearModal();
    }
  };

  onClearModal = () => {
    this.props.onClearModal();
    this.props.reset();
  };

  submitCreateTrackedVideo = async formData => {
    const data = { assetURL: formData.get('assetURL') };
    if (this.props.campaignId) data.campaignId = this.props.campaignId;
    if (this.props.discussionId) data.discussionId = this.props.discussionId;
    if (this.props.discussionName) data.discussionName = this.props.discussionName;
    this.props.onAddTrackedVideo(data, this.onClearModal);
  };

  updateUploaderState = newUploaderState => {
    this.setState({ uploaderState: newUploaderState });
  };

  render() {
    const { handleSubmit, showModal, modalLoading, modalError } = this.props;

    return (
      <div className={showModal === TRACKED_ASSET ? 'custom-modal visible' : 'custom-modal'} onClick={this.onOutsideClick}>
        <form onSubmit={handleSubmit(this.submitCreateTrackedVideo)}>
          <div className="modal-content" ref="modal_content">
            <div className="top no-border">
              <h3>Track a new deliverable</h3>
              <p>You can currently track Youtube, Facebook and Instagram deliverables</p>
            </div>
            <div className="modal-close no-border">
              <img src="/icons/close.svg" alt="close" onClick={this.onClearModal} />
            </div>
            <div className="center">
              <div className="spacer large" />
              <table>
                <tbody>
                  <tr>
                    <td colSpan="3">
                      <Field
                        name="assetURL"
                        className="small-margin"
                        type="text"
                        label="Add a URL"
                        component={TextInput}
                        placeholder="The deliverable URL"
                      />
                      <p>
                        <a href="http://help.dyzio.co/getting-started/how-to-find-trackable-asset-urls" target="_blank">where do I find the live URL for my deliverable?</a>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      { modalError &&
                        <div className="center-all">
                          <p>{modalError}</p>
                        </div>
                      }
                      <div className="spacer" />
                      <button className="medium rose stretch" type="submit">
                        { modalLoading ?
                          <ul className="dots">
                            <li id="dot1" />
                            <li />
                            <li id="dot2" />
                            <li />
                            <li id="dot3" />
                          </ul>
                          : <span>track this deliverable</span>
                        }
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

TrackAssetModal.propTypes = {
  routeParams: React.PropTypes.object,
};

function validate(values) {
  const errors = {};

  const assetURL = values.get('assetURL');

  if (!assetURL) {
    errors.assetURL = 'Please enter an asset URL';
  } else {
    /* TODO Use the helper function to determine whether valid
    const checkValid = extractYoutubeVideoID(assetURL);
    if (!checkValid) {
      errors.assetURL = 'Please enter a valid asset URL';
    }
    */
  }

  return errors;
}

const mapStateToProps = state => ({
  userData: state.userData.get('userData'),
  showModal: state.modal.get('showModal'),
  modalLoading: state.modal.get('loading'),
  modalError: state.modal.get('error'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onClearModal: () => dispatch(clearModal()),
    onAddTrackedVideo: (data, callback) => dispatch(addTrackedVideo(data, callback)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'TrackAssetForm',
    validate,
  })(TrackAssetModal),
);



/** WEBPACK FOOTER **
 ** ./src/containers/track-asset-modal/index.js
 **/